/**
 * Created by jonas on 2019-08-21.
 */

import {Timeline, TimelineLite} from "gsap";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {HarlequinSoundConfig} from "../HarlequinSoundConfig";
import {HarlequinGameModuleConfig} from "../HarlequinGameModuleConfig";
import {HarlequinParsedGameData} from "../server/data/HarlequinParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GameRoundManager} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundManager";

export class WinEnd implements GameRoundPresentation {

    stagger?:number;
    abortStagger?:number;
    private _hasWin:boolean;
    private _tl:TimelineLite | undefined;
    private _aborted:boolean = false;

    private _goingToFs:boolean;
    private _exitingFs:boolean;
    private _exitingRespin:boolean;

    constructor(stagger?:number, abortStagger?:number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
    }

    public prepare(data:ParsedGameData):void {
        this._aborted = false;
        this._hasWin = data.singleWin > 0;
        this._goingToFs = (data.mode === "NORMAL" && data.nextMode === "FREESPIN") || (data.mode === "WILD_RESPIN" && data.nextMode === "FREESPIN");
        this._exitingFs = (data.mode === "FREESPIN" && data.nextMode === "NORMAL");
        this._exitingRespin = ((data.mode === "WILD_RESPIN" && data.nextMode === "NORMAL") || (data.mode === "WILD_RESPIN_FS" && data.nextMode === "FREESPIN"))
        || data.mode === "WILD_RESPIN_FS" && data.nextMode === "NORMAL";

        this._tl = undefined;
    }

    public getAnimation(data:HarlequinParsedGameData):Timeline | null {
        if (!this._hasWin) {
            return null;
        }
        this._tl = new TimelineLite();

        if (data.isBigWin) {
            this._tl.add(() => {
                SlotGame.sound.fadeEffect(HarlequinSoundConfig.instance.BIG_WIN, 0, 1500);
                SlotGame.sound.fadeAmbience(1, 1500);
                HarlequinGameModuleConfig.winTextView.end(data.currentWinRatioConfig!, 1, 0.2, true);
                SlotGame.sound.playEffect(HarlequinSoundConfig.instance.BIG_WIN_ENDS);
            }, 0);

            this._tl.add(() => {
                SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.BIG_WIN);
                SlotGame.sound.stopEffect(HarlequinSoundConfig.instance.BIG_WIN_COUNTUP);
            }, 1.5);
        }

        this._tl.add(() => HarlequinGameModuleConfig.countUpView.end(+data.totalSpinWinnings, 1, 0.2), 0);

        if(this._hasWin && (this._exitingFs || this._exitingRespin || this._goingToFs)) {
            //console.log("TL DELAY ADD");
            this._tl.add(() => {}, "+=1.0");
        }

        return this._tl;
    }

    public abort(isActive:boolean, data:ParsedGameData):Timeline | null {
        if (isActive && this._tl) {
            if(this._exitingFs || this._exitingRespin || this._goingToFs) {
                //console.log("RETURNING TL");
                return this._tl;
            } else {
                //console.log("DETACHED TL");
                GameRoundManager.detachAndPlayTimeline(this._tl);
            }
        }
        return null;
    }
}